import { useLocation, useNavigate } from "react-router-dom";
import Navbar from "../../../components/molecules/Navbar";
import Footer from "../../../components/molecules/Footer";
import styles from "../index.module.css";

function EligibilityRejected() {
  const location = useLocation();
  const navigate = useNavigate();
  const userData =
    location.state?.data ||
    JSON.parse(sessionStorage.getItem("eligibility_data") || "{}");

  const reasons = [
    { icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
        <circle cx="12" cy="12" r="9" stroke="#d32028" strokeWidth="1.6" />
        <path d="M12 8V12M12 16H12.01" stroke="#d32028" strokeWidth="1.8" strokeLinecap="round" />
      </svg>
    ), text: "Policy criteria not met at this time" },
  ];

  return (
    <div className={styles.body}>
      <div className={styles.backdrop}>
        <Navbar />
        <div className={styles.main}>
          <div className={styles.cardWrapper}>
            <div className={styles.container}>

              {/* ── Badge ── */}
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center", paddingTop: "0.5rem", paddingBottom: "0.6rem" }}>
                <div
                  style={{
                    width: "72px",
                    height: "72px",
                    borderRadius: "20px",
                    background: "linear-gradient(135deg, #6b7280 0%, #4b5563 100%)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: "0 8px 24px rgba(107,114,128,0.28)",
                    marginBottom: "1rem",
                  }}
                >
                  <svg width="36" height="36" viewBox="0 0 36 36" fill="none">
                    <path d="M11 11L25 25M25 11L11 25" stroke="white" strokeWidth="3" strokeLinecap="round" />
                  </svg>
                </div>

                <p style={{ fontSize: "1.35rem", fontWeight: 800, color: "#1a1a2e", margin: "0 0 0.35rem", fontFamily: "Outfit, sans-serif", textAlign: "center", letterSpacing: "-0.3px" }}>
                  Application Not Approved
                </p>
                <p style={{ fontSize: "0.84rem", color: "#777", margin: 0, textAlign: "center", lineHeight: 1.55 }}>
                  We cannot process your application at this time.
                </p>
              </div>

              {/* ── Explanation card ── */}
              <div style={{ background: "#fff", border: "1px solid #e8e8e8", borderRadius: "14px", padding: "1rem 1.15rem", marginBottom: "0.9rem" }}>
                <p style={{ margin: "0 0 0.75rem", fontSize: "0.8rem", fontWeight: 700, color: "#444", textTransform: "uppercase", letterSpacing: "0.7px" }}>
                  Possible reasons
                </p>
                <div style={{ display: "flex", flexDirection: "column", gap: "0.7rem" }}>
                  {reasons.map((r, i) => (
                    <div key={i} style={{ display: "flex", alignItems: "flex-start", gap: "0.7rem" }}>
                      <div style={{ width: "32px", height: "32px", borderRadius: "8px", background: "#fdecea", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                        {r.icon}
                      </div>
                      <p style={{ margin: 0, fontSize: "0.84rem", color: "#555", lineHeight: 1.5, paddingTop: "0.45rem" }}>
                        {r.text}
                      </p>
                    </div>
                  ))}
                </div>
              </div>

              {/* ── What next ── */}
              <div style={{ display: "flex", alignItems: "flex-start", gap: "0.65rem", background: "#f9fafb", border: "1px solid #e5e7eb", borderRadius: "10px", padding: "0.8rem 0.9rem", marginBottom: "0.9rem" }}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" style={{ flexShrink: 0, marginTop: "1px" }}>
                  <circle cx="12" cy="12" r="9" stroke="#6b7280" strokeWidth="1.7" />
                  <path d="M12 11V16" stroke="#6b7280" strokeWidth="1.8" strokeLinecap="round" />
                  <circle cx="12" cy="8" r="0.8" fill="#6b7280" />
                </svg>
                <p style={{ margin: 0, fontSize: "0.8rem", color: "#555", lineHeight: 1.6 }}>
                  You may re-apply after{" "}
                  <strong style={{ color: "#374151" }}>90 days</strong>
                  . For assistance, reach out to our support team.
                </p>
              </div>


            </div>

            {/* <div style={{ padding: "0.75rem 1.25rem 1rem", display: "flex", justifyContent: "center" }}>
              <button
                onClick={() => navigate("/eligibility/email", { state: { data: userData } })}
                style={{ background: "none", border: "none", color: "#bbb", fontSize: "0.78rem", cursor: "pointer", fontFamily: "Outfit, sans-serif", textDecoration: "underline" }}
              >
                Skip
              </button>
            </div> */}
          <Footer light />
          </div>
        </div>
      </div>
    </div>
  );
}

export default EligibilityRejected;
